import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IDropdownModel } from "common/models/IDropdownModel";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import { memberStatusView } from "../types/memberStatusView";
import {
  IMemberStatus,
  IMemberStatusGridFilter,
  IMemberStatusGridModel,
} from "./types";

export const memberStatus = createQueryKeys("memberStatus", {
  list: (postModel: PostModel<IMemberStatusGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<IMemberStatusGridModel>>(
        endpoints.memberStatus.list,
        postModel
      ),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () =>
      api.get<IMemberStatus>(`${endpoints.memberStatus.getById}/${Id}`),
  }),

  getMemberStatusValues: () => ({
    queryKey: ["GetMemberStatusValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.memberStatus.getMemberStatusValues),
  }),

  getViewById: (Id: string | number | undefined) => ({
    queryKey: ["modal", Id],
    queryFn: () =>
      api.get<memberStatusView>(`${endpoints.memberStatus.view}/${Id}`),
  }),
});
